"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareVersion = compareVersion;
exports.toSemver = toSemver;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @file Semver compare
 * @module semver
 * @date 2019-05-13
 */

/**
 * Convert to semver
 * @example
 * toSemver('1.2.3') => [1, 2, 3]
 *
 * @param {string} verStr 版本号
 * @returns {string|number[]}
 */
function toSemver(verStr) {
  if (verStr) {
    var _verStr$split = verStr.split('.'),
        _verStr$split2 = _slicedToArray(_verStr$split, 3),
        _verStr$split2$ = _verStr$split2[0],
        major = _verStr$split2$ === void 0 ? '' : _verStr$split2$,
        _verStr$split2$2 = _verStr$split2[1],
        minor = _verStr$split2$2 === void 0 ? '' : _verStr$split2$2,
        _verStr$split2$3 = _verStr$split2[2],
        patch = _verStr$split2$3 === void 0 ? '' : _verStr$split2$3;

    return [+major, +minor, +patch];
  } else {
    return '';
  }
}
/**
 * Compare two semver
 * @param {string} a '1.2.3'
 * @param {string} b '1.2.3'
 * @returns {number} a > b => 1; a < b => -1; a = b => 0
 * @example
 * compareVersion('1.3.1', '1.3.7') = -1
 */


function compareVersion(a, b) {
  var pa = a.split('.');
  var pb = b.split('.');

  for (var i = 0; i < 3; i++) {
    var na = +pa[i];
    var nb = +pb[i];

    if (na > nb) {
      return 1;
    }

    if (nb > na) {
      return -1;
    }

    if (!isNaN(na) && isNaN(nb)) {
      return 1;
    }

    if (isNaN(na) && !isNaN(nb)) {
      return -1;
    }
  }

  return 0;
}